<template>
    <section id="headline" class="d-flex flex-column align-items-start">
        <div class="headline">
            <p>
                #1 Platform for <br> Cross-Promotion
            </p>
            <p>
                Wow! Now it is easy to help each other <br> get more backers to your crowdfunding <br> campaigns. Get it done. <b>FOR FREE.</b>
            </p>
        </div>
        <div class="mt-5">
            <button
                @click="showModal"
                class="c16 p2bl">
                    Start Now
            </button>
        </div>
    </section>
</template>

<script>
import SignUp from '../../popups/SignUp'
export default {
    name: 'HeadLine',
    components: {
        SignUp
    },
    methods: {
        showModal(){
            this.$store.commit('TOGGLE_MODAL', ['sign-up', {
                openedFrom: 'Hero Image Start Now'
            }]);
        }
    }
}
</script>

<style scoped lang="scss">
div.headline {
    p:first-child {
        font-weight: bold;
        font-size: 62px;
        color: #FFFFFF;
        text-shadow: -4px 2px 0px rgba(14, 40, 94, 0.7);
        line-height: 115%;
    }
    p:last-child {
        color: #B3C3FF;
        font-size: 24px;
        line-height: 160%;
    }
}
button {
    width: 150px;
    height: 53px;
    background: linear-gradient(134.78deg, #0ACF97 5.45%, #0EAAE7 74.58%);
    border-radius: 5px;
    transition: all 0.2s ease;

    &:hover {
        box-shadow: 0px 13px 27px rgba(14, 170, 231, 0.46);
    }
}
</style>